import { useEffect, useState } from "react";
import * as icons from 'react-bootstrap-icons';

export default function Inputer({
    id,
    type,
    placeholder,
    value,
    setValue,
    icon,
    className,
    min,
    onKeyEnterActive,
    onKeyEnter,
    readOnly = false,
    searchMode,
    cancelSearch,
    disabled,
    force
}) {
    const [notEmpty, setNotEmpty] = useState(false);
    const [empty, setEmpty] = useState(true);
    const unic_id = Date.now();
    const handleOnBlur = () => {
        let div = document.getElementById(`inputer-${id}-${unic_id}`);
        div.classList.remove('active');
    }
    const handleOnFocus = () => {
        let div = document.getElementById(`inputer-${id}-${unic_id}`);
        div.classList.add('active');
        div.childNodes[1].focus();
    }
    const handleOnFocus_icon = () => {
        let div = document.getElementById(`inputer-${id}-${unic_id}`);
        div.classList.add('active');
        div.childNodes[1].focus();
    }
    const handleOnChange = (e) => {
        try {
            setValue(id, e.target.value);
            if(e.target.value !== '') setEmpty(false);
            else setEmpty(true);
        } catch {}
    }

    useEffect(() => {
        if(value !== "") setNotEmpty(true);
        else setNotEmpty(false);
    },[value])

    const onPressEnter = (event) => {
        if(onKeyEnterActive && event.keyCode === 13) {
            onKeyEnter();
        }
    }
    
    return (
        <div id={`inputer-${id}-${unic_id}`} className={`inputer ${className ? className : ''}`} onClick={handleOnFocus_icon}>
            <div className='title'>
                {
                    notEmpty &&
                    <div className="text">
                        {placeholder}
                    </div>
                }
                {
                    (searchMode && !empty)
                    ? <div className="icon" onClick={cancelSearch}>
                        <icons.XLg />
                    </div>
                    : <div className="icon">
                        {icon}
                    </div>
                }
                
            </div>
            <input
                type={type}
                placeholder={placeholder}
                defaultValue={value}
                onChange={handleOnChange}
                onFocus={handleOnFocus}
                onBlur={handleOnBlur}
                readOnly={readOnly}
                onKeyUp={onPressEnter}
                disabled={disabled}
                className={type}
            />
            {force && <strong className="text-danger">*</strong>}
        </div>
    );
}